@if (template && groups) {
  <div class="p-2 container">
    <form (ngSubmit)="saveTemplate()" ngNativeValidate>
      <div class="d-flex justify-content-end align-items-center">
        <button class="btn btn-success px-4" type="submit">
          {{(newTemplate ? 'create' : 'save' )| translate}}
        </button>
      </div>
      @if (!isBrowser) {
        <div class="col-12 col-md-6 mx-auto">
          <div class="form-group">
            <label for="name">{{'Name'|translate}}</label>
            <input type="text" name="name" class="form-control" required [(ngModel)]="template.name" />
          </div>
          @for (mod of modules; track mod) {
            <div class="form-group">
              <label>
                <span class="me-2">{{'module'|translate}}</span>{{('modules.'+mod)|translate}}
              </label>
              <ng-select [items]="groups[mod]" [(ngModel)]="template['mod_'+mod]" [name]="mod" placeholder="---"
                bindValue="id_group" bindLabel="name">
              </ng-select>
            </div>
          }
        </div>
      }
      @if (isBrowser) {
        <div class="col-12 col-md-6 mx-auto">
          <div class="form-group">
            <label for="name">{{'browser.id_browser'|translate}}</label>
            <input type="text" name="name" class="form-control" required [(ngModel)]="template.id_browser" />
            <i>{{'browser.id_has_to_be_exact'|translate}}</i>
          </div>
          <table>
            @for (mod of modules; track mod) {
              <tr>
                <td>
                  <span class="me-2">{{'module'|translate}}</span>{{('modules.'+mod)|translate}}:
                </td>
                <td>
                  <ui-switch [(ngModel)]="template['mod_'+mod]" [name]="mod" checkedLabel="1" uncheckedLabel="0">
                  </ui-switch>
                </td>
              </tr>
            }
          </table>
        </div>
      }
    </form>
  </div>
}
